<template>
    <div id="sala-prensa"> 
        <!-- CAMBIA BANNER, SI ES SALA DE PRENSA O SI ES UN ARTICULO -->
        <div v-if="vista_detalle">
            <div class="titulo-contenido-prensa"></div>
        </div>
        <div v-else  class="titulo-contenido-prensa2">
            <center><h1> SALA DE PRENSA</h1></center>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-9 col-sm-12 order-md-1 order-2">
                    <!-- {{anio_act}} - {{articulo_act}} -->
                    <div v-show="!(anio_act && articulo_act)" style="height:70%;">
                        <spiner></spiner>
                        <h6 class="text-center text-muted"> Cargando contenido...</h6> 
                    </div>
                    <template v-if="anio_act && articulo_act">
                        <router-view></router-view>
                    </template>
                </div>
                <div class="col-md-3 col-sm-12 order-md-2 order-1">
                
                    <!-- Button trigger modal moviles -->
                    <div v-if="filtros">
                        <button type="button" class="btn filtros Shoulders700-text mb-3" data-toggle="modal" data-target="#exampleModal">
                            <i class="fa fa-filter" aria-hidden="true"></i>  FILTROS
                        </button>

                        <!-- Modal -->
                        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div id="modal-contenedor" class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title Shoulders700-text" id="exampleModalLabel"><i class="fa fa-filter" aria-hidden="true"></i>  FILTROS</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <filtros-prensa></filtros-prensa>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="filtro-resolucion-grande"> <!--resolucion-grande-->
                        <filtros-prensa class=" mt-4"></filtros-prensa>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>

import filtrosPrensa from './filtros.vue';
import spiner from '../spiner.vue'
import { mapState } from "vuex";
export default {
    data: function(){
        return{
            anio_act: false,
            articulo_act: false
        }
    },
    computed:{
        filtros(){ return (screen.width<770)? true : false; },
        ubicacion(){  return (window.location.pathname !== '/prensa/vista-detalle')? true : false; },
        ...mapState(['anio_actual', 'articulo_actual', 'vista_listado', 'vista_detalle'])
    },
    components:{
        filtrosPrensa,
        spiner,
    },
    methods:{
        /*
                VALIDA QUE LA RUTA ENTRE A VISTA LISTADO AUNQ LA URL MARQUE /PRENSA/
         */
        validar_ruta(){
            const path = window.location.hostname=="localhost"? 
                'prensa' :
                'haciendaChiapas/prensa' /* ### ESTA CADENA PUEDE VARIAR A LA HORA DE IR A CALLE */

            if(window.location.pathname == `/${path}` || window.location.pathname == `/${path}/`){
                this.$router.push({name: 'listado'});
            }
        }
        
    },
    watch:{
        anio_actual: function(){
            this.anio_act = true;
        },
        articulo_actual: function(){
            this.articulo_act = true;
        }
    },
    created(){
        this.validar_ruta();
    }
    
}
</script>
<style scoped>
/* Row coloca espaciado q se desborda. se lo quito */
    #sala-prensa > .row{ margin-right: 0 !important; }

/* lo quite pues veo q los sitios con filtros no los dejan fijo
.filtro-resolucion-grande{
    position: -webkit-stick !important;
    position: sticky !important;
    top: 5rem !important;
    z-index: 1000 !important;
} */


/* CONTROLADOR DE FILTROS FLOTANTE (MOVIL)*/
    .filtros{
        color: #868686;
        letter-spacing: 2px;
        display: none;
        width: 100%;
        text-align: left;
        background: #ededed;
    }

    .modal { z-index: 2000; }
    .modal-content { height: auto; } /*| celulares grandes = 100vh |*/
    .modal-content2 { height: auto; } /*|celulares pqños    |*/
    .modal-dialog { margin: 0; }


    .btn.focus, .btn:focus {
        outline: 0;
        box-shadow: none;
    }

    .modal-header h5{
        color: #b3b3b3;
        letter-spacing: 1px;
    }
    

    @media only screen and (max-device-width : 771px) {
        /* FILTROS, RESOLUCIONES PQÑAS */
        .filtros{ display: block; } 
        hr{ display: none; } 
        .resolucion-grande{ display: none; }
    }
</style>